import Client from './client';
import { Auth } from 'aws-amplify';
import { Logger } from '../_clean-code/utils/logger';
import { SELECTED_COMPANY_ID } from '../constants';

let endpoint = import.meta.env.VITE_APP_ENDPOINT;
if (endpoint && !endpoint.startsWith('http')) {
  endpoint = `https://${endpoint}`;
}
const baseUrl = endpoint || 'https://dev-api.pulsarml.com';

const api = Client.create(baseUrl);
api.addErrorInterceptor((error) => {
  if (error.response?.status === 401) {
    Auth.currentAuthenticatedUser({ bypassCache: true }).catch(() => {
      localStorage.clear();
      window.location.href = '/login';
      Logger.info(
        'legacy-client::api::response: 401 error, clearing localStorage and redirecting to login'
      );
    });
  } else if (error.response && error.config?.url) {
    Logger.apiError(
      `legacy-client::api::response: ${error.message} calling ${error.config.url}`,
      error
    );
  }
  if (
    error.response?.status === 403 &&
    error.response?.data.message === 'FORBIDDEN: Invalid Company'
  ) {
    localStorage.removeItem(SELECTED_COMPANY_ID); // this resets the company selection
    Logger.info('Company not found, clearing localStorage company selection');
  }

  return Promise.reject(error);
});

export const BASE_URL = baseUrl;

window.app = {
  isApiLocal: false,
  setApiLocal: () => (window.app.isApiLocal = true),
  setApiRemote: () => (window.app.isApiLocal = false)
};

export default api;
